import { AggregateQueryInterval } from "~/modules/filters/types";

export enum MetricTypes {
    TotalValue = "total_value",
    AssetHolders = "asset_holders",
    ActiveAddresses = "active_addresses",
    TransferVolume = "transfer_volume",
    MintBurnVolume = "mint_burn_volume",
    Apy7Day = "apy_7_day",
}

export interface LegendProps {
    enabled: boolean;
    active: boolean;
    align?: "left" | "right" | "center";
    layout?: "vertical" | "horizontal";
    verticalAlign?: "top" | "bottom";
    itemWidth?: number;
    maxHeight?: number;
}

export interface NavigatorProps {
    enabled: boolean;
    active: boolean;
    xAxis?: {
        min: number | null;
        max: number | null;
    };
}

export interface DistributionSelectProps {
    distributed: {
        enabled: boolean;
    };
    represented: {
        enabled: boolean;
    };
    stablecoins: {
        enabled: boolean;
        active: boolean;
    };
}

export interface MetricsProps {
    options: MetricTypes[];
}

export interface StackedProps {
    enabled: boolean;
    active: boolean;
}

export interface GroupByProps {
    value: string;
    enabled?: boolean;
    allowedOptions?: string[];
    labelOverrides?: Record<string, string>;
}

export interface IntervalProps {
    value: AggregateQueryInterval;
    enabled?: boolean;
    allowedOptions?: AggregateQueryInterval[];
}
